import { Component, Input } from '@angular/core';
import { IServiceOpcode, OpcodeType } from '@signal/asp-data-commons';

@Component({
  selector: 'app-opcode-item',
  templateUrl: './opcode-item.component.html',
  styleUrls: ['./opcode-item.component.scss']
})
export class OpcodeItemComponent {

  @Input() item: IServiceOpcode;
  @Input() index: number;

  isValidOpcode(opcode : IServiceOpcode){
    return opcode.opcode && opcode.displayName && opcode.description && opcode.labourHours &&
      (opcode.opcodeType === OpcodeType.MAINTENANCE ? !!opcode.mileages : true) && (opcode?.isInternalCode ? opcode?.mapDmsCode && opcode?.mapDmsCode?.opcode : true);
  }

}
